import { observer } from 'mobx-react-lite'
import { WebMCPProvider, useMcpTool } from 'webmcp-react'
import { useWebMcpEnabled } from 'entities/WebMcp/lib/flag'
import { okResult, errorResult } from 'entities/WebMcp/lib/toolResult'
import { filterConversationsListSchema } from 'entities/WebMcp/model/schemas'
import { useConversationsPageContext } from 'pages/conversations/context/conversationsPageContext'
import {
  filterConversationsList,
  FILTER_CONVERSATIONS_LIST_GUIDANCE,
} from 'pages/conversations/ui/webmcp/filterConversationsList'

const ConversationsListSyncToolsInner = () => {
  const store = useConversationsPageContext()

  useMcpTool({
    name: 'filter_conversations_list',
    description:
      "Filter the conversation list on the open conversations page (e.g. {filter: 'unread'}). Applies the filter to the on-screen list the same way the user's own quick-filter control does, and returns the matching conversations (id, contact, unread count, last message). Prefer this over list_unread_conversations while the conversations page is open, so the interface stays in sync. Use a returned conversation id with reply_to_conversation.",
    input: filterConversationsListSchema,
    annotations: { readOnlyHint: true },
    handler: async ({ filter }) => {
      try {
        return okResult(
          await filterConversationsList(store.conversationListStore, filter),
          FILTER_CONVERSATIONS_LIST_GUIDANCE
        )
      } catch (e) {
        return errorResult(e)
      }
    },
  })

  return null
}

/**
 * Page-scoped WebMCP tool that drives the conversation list UI (the contextual
 * UI-driving pattern). Mounted with the conversations page, bound to the live
 * ConversationListStore, so filtering through the agent updates the on-screen list
 * rather than answering only in the chat. Gated by the agent flag; the inner
 * WebMCPProvider matches the global one so useMcpTool registers on the same
 * navigator.modelContext.
 */
export const ConversationsListSyncTools = observer(() => {
  const enabled = useWebMcpEnabled()
  if (!enabled) return null
  return (
    <WebMCPProvider name='salesmsg-conversations-page' version='0.1.0'>
      <ConversationsListSyncToolsInner />
    </WebMCPProvider>
  )
})
